import { useState } from 'react'
import { HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi'

export default function PasswordInput({ disabled, ...inputProps }) {
  const [visible, setVisible] = useState(false)

  return (
    <div className="password-input">
      <input
        {...inputProps}
        type={visible ? 'text' : 'password'}
        disabled={disabled}
      />
      <button
        type="button"
        className="password-toggle"
        onClick={() => setVisible((current) => !current)}
        disabled={disabled}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
      >
        {visible ? <HiOutlineEyeOff /> : <HiOutlineEye />}
      </button>
    </div>
  )
}
